import { prefixes } from '@akademiasaas/shared';

export interface PhonePrefixOption {
  value: string;
  label: string;
}

/**
 * Kierunkowe jako „PL +48” (bez obrazków flag z zewnętrznego serwera). Wartością jest kod kraju,
 * bo ten sam numer kierunkowy ma kilka krajów (np. +1) — antd `Select` wymaga unikalnych wartości.
 */
export const PHONE_PREFIX_OPTIONS: PhonePrefixOption[] = [...prefixes]
  .sort((a, b) => Number(a.value) - Number(b.value) || a.country.localeCompare(b.country))
  .map(({ country, value }) => ({ value: country, label: `${country} +${value}` }));

/** Numer zapisywany w profilu: `+48600123456` albo `null`, gdy pole puste (telefon jest opcjonalny). */
export function phoneWithPrefix(country: string, number: string | undefined): string | null {
  const digits = (number ?? '').replace(/[\s-]/g, '');
  if (!digits) return null;
  const prefix = prefixes.find((item) => item.country === country)?.value ?? '48';

  return `+${prefix}${digits}`;
}

/** Numer bez kierunkowego: cyfry, spacje i myślniki, 6–15 cyfr (E.164 bez prefiksu kraju). */
export const PHONE_NUMBER_PATTERN = /^(?=(?:\D*\d){6,15}\D*$)[\d\s-]+$/;
